module.exports = __webpack_public_path__ + "assets/img/join-back-02.004e0cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/join-back-02.png
// module id = t47P
// module chunks = 1